import { Suspense } from 'react';
import CoinAndLevelUp from '@/components/level-up/coin-levelup';
import { DMLink } from '@/components/link';
import { formatDateToDDMMMYYYY } from '@/lib/utils';
import CourseFeatures from './course-features';
import CourseDetailsHeader from './header';
import CourseIntroVideo from './intro-video';
import PaymentButton from './razorpay/PaymentButton';
import type { CourseDetailsProps } from './types';

export const CourseDetailsSm = ({ className, courseDetails }: CourseDetailsProps) => {
  return (
    <div className={`flex justify-between lg:flex-row flex-col ${className}`}>
      <div className='aspect-[16/9]'>
        <Suspense fallback={null}>
          <CourseIntroVideo link={courseDetails?.chapters?.[0]?.lectures?.[0]?.link ?? ''} />
        </Suspense>
      </div>

      <CourseDetailsHeader
        title={courseDetails?.title}
        description={courseDetails?.description || ''}
        createdBy='Debug Media'
        updatedOn={formatDateToDDMMMYYYY(courseDetails?.updatedAt)}
      />
      <div className='mt-5 p-2'>
        <CourseFeatures />
        <CoinAndLevelUp coin={courseDetails?.coin} points={courseDetails?.point} />
        {/* <EnrollButton title={courseDetails.title} slug={courseDetails.slug} fee={courseDetails.price} /> */}
        {courseDetails?.orders?.[0]?.active ? (
          <DMLink
            className='flex items-center justify-center mb-4 mt-4'
            href={`/courses/${courseDetails?.slug}/${courseDetails?.chapters?.[0]?.lectures?.[0]?.slug}`}
            variant='primary_outline'
          >
            Go to course
          </DMLink>
        ) : (
          <PaymentButton courseDetails={courseDetails} />
        )}
      </div>
    </div>
  );
};

export default CourseDetailsSm;
